/**
 * Класс для загрузки аватара
 * @constructor
 */
class AvatarLoader {
    constructor(opts) {
        this.$profileId = $(`#${opts.profileId}`); // id'шник блока с изображением
        this.$inputFile = this.$profileId.find(`.${opts.inputCls}`); // класс input file
        this.$avatarImg = this.$profileId.find(`.${opts.imgCls}`); // класс изображения

        this.init();
    }

    handleEvents() {
        this.$inputFile.on('change', (e) => {
            const inputFiles = e.target.files;

            if (inputFiles.length) {
                const file = inputFiles[0];
                const reader = new FileReader();

                reader.onload = () => {
                    this.$avatarImg.attr('src', reader.result);
                };

                const data = reader.readAsDataURL(file);
            }
        });
    }

    init() {
        this.handleEvents();
    }
}

const avatarLoader = new AvatarLoader({
    profileId: 'profile-avatar',
    inputCls: 'js-profile-input',
    imgCls: 'js-profile-img',
});
const ACTION_ENDPOINT = 'ibrush:lib.api';

const apiUrls =  {
    'work_func_code_search' : '/ajaxController.searchcontroller.workfunctionsearchbycode',
    'work_func_name_search' : '/ajaxController.searchcontroller.workfunctionsearchbyname',
    'standard_search' : '/ajaxController.searchcontroller.professionalstandardsearch',
    'project_search' : '/ajaxController.searchcontroller.projectsearch',

    'project_pdf' : '/personal/projects/download/pdf.php',
    'add_comment' : '/ajax/add-comment.php',
    'like_comment' : '/ajax/project-comment-like.php',
    'project_field_edit' : '/ajax/project-field-edit.php',
    'change_password_by_checkword' : '/ajax/change-password-by-checkword.php',
    'change_password' : '/ajax/change-password.php',
    'create_dialogue' : '/ajax/create-dialogue.php',
    'add_dialogue_user' : '/ajax/add-dialogue-user.php',
    'add_dialogue_message' : '/ajax/add-dialogue-message.php',
    'update_dialogue_last_visit' : '/ajax/update-dialogue-last-visit.php',
};

const apiActions = {
    'project_group_search' : 'searchcontroller.projectgroupsearch',
    'clear_notifications' : 'notificationcontroller.clearnotifications',
    'edit_profile' : 'userscontroller.editprofile',
    'change_avatar' : 'userscontroller.changeavatar',
    'create_conference_notifications' : 'notificationcontroller.createconferencenotifications',
    'change_notifications_settings' : 'notificationcontroller.changesettings',
    'add_expertise_file' : 'expertisecontroller.addexpertisefile',
    'project_status_change' : 'projectcontroller.changestatus',
    'create_mailing' : 'mailingscontroller.createmailing',
    'users_search' : 'userscontroller.searchusers',
    'download_note' : 'documentscontroller.downloadnote',
    'download_conclusion' : 'documentscontroller.downloadconclusion',
    'generate_from_template' : 'documentscontroller.generatefromtemplate',
    'add_spk_result' : 'projectcontroller.addspkresult',
    'add_expertise' : 'expertisecontroller.addexpertise',
    'edit_mailing' : 'mailingscontroller.editmailing',
    'change_recipients' : 'mailingscontroller.changerecipients',
    'filter_projects' : 'projectcontroller.filterprojects',
    'create_project' : 'projectcontroller.createproject',
    'return_project_to_nark' : 'projectcontroller.returntonark',
    'project_remake' : 'projectcontroller.remake',
    'create_project_group' : 'projectcontroller.creategroup',
    'add_projects_to_group' : 'projectcontroller.addtogroup',
    'rename_group' : 'projectcontroller.renameproject',
    'delete_from_group' : 'projectcontroller.deletefromgroup',
    'get_ps_requisites' : 'projectcontroller.getpsrequisites',
};

function getUrl(name) {
  return apiUrls[name];
}

function getAction(name) {
    return ACTION_ENDPOINT + '.' + apiActions[name]
}

const qs = sel => document.querySelector(sel);
const qsa = sel => document.querySelectorAll(sel);
const isRequired = () => { throw new Error('Param is required'); };
const APP = {
	name: 'iBrush PMK'
};
$(() => {
    $('body').on('change', '.js-choice-list-input', function() {
        const $this = $(this);
        const $parent = $this.closest('.js-developer-inner');

        $parent[($this.is(':checked') ? 'add' : 'remove') + 'Class']('is-active');
    });

    // Проверяем, заполнено поле или нет
    $(document).on('input', '.input, .textarea', function() {
        const $this = $(this);

        $this.closest('.group')[($.trim($this.val()) ? 'add' : 'remove') + 'Class']('is-filled');
    });

    $('.radio').on('change', function() {
        $(this).closest('.js-radio-group').removeClass('is-unchecked');
    });
});

document.addEventListener("DOMContentLoaded", () => {
    myProjectPage()
});

function myProjectPage() {
    let projectList = document.querySelector('.project-list');

    if (projectList === null) {
        return
    }

    function myProject() {
        let projectCard = projectList.querySelectorAll('.project-card');

        return {
            makeSmallCards() {
                for (let i = 0; i < projectCard.length; i++) {

                    if (projectCard[i].classList.contains('project-card_small')) {
                        return
                    } else {
                        projectCard[i].classList.add('project-card_small')
                    };
                }
            },

            makeBigCards() {
                for (let i = 0; i < projectCard.length; i++) {
                    projectCard[i].classList.remove('project-card_small')
                }
            },

            selectAllCheckbox() {
                for (let i = 0; i < projectCard.length; i++) {
                    if (projectCard[i].querySelector('.checkbox')) {
                        projectCard[i].classList.add('project-card_selected');
                        projectCard[i].querySelector('.checkbox').checked = true
                    }
                }
            },

            unSelectAllCheckbox() {
                for (let i = 0; i < projectCard.length; i++) {
                    if (projectCard[i].querySelector('.checkbox')) {
                        projectCard[i].classList.remove('project-card_selected');
                        projectCard[i].querySelector('.checkbox').checked = false
                    }
                }
            },

            addClassSelectedCard(checkbox) {
                checkbox.closest('.project-card').classList.add('project-card_selected')
            },

            removeClassSelectedCard(checkbox) {
                checkbox.closest('.project-card').classList.remove('project-card_selected')
            },
        }
    }

    let myProjectFunction = myProject();

    function myProjectWork() {
        let btnSetSmall = document.querySelector('.js-select-project');
        let btnUnSmall = document.querySelector('.js-unselect-project');
        let btnSelectAll = document.querySelector('.js-select-all-project');
        let allCheckbox = document.querySelectorAll('.js-project-checkbox');
        let banner = document.querySelector('.project-select-banner');


        btnSetSmall.addEventListener('click', () => {
            myProjectFunction.makeSmallCards();
            myProjectFunction.unSelectAllCheckbox();

            btnSetSmall.classList.add('_hidden');
            btnSetSmall.nextElementSibling.classList.remove('_hidden');
            banner.classList.add('project-select-banner_visible')
        });

        btnUnSmall.addEventListener('click', () => {
            myProjectFunction.makeBigCards();
            myProjectFunction.unSelectAllCheckbox();

            btnUnSmall.classList.add('_hidden');
            btnUnSmall.previousElementSibling.classList.remove('_hidden');
            banner.classList.remove('project-select-banner_visible')
        });

        btnSelectAll.addEventListener('click', () => {

            if (btnSelectAll.classList.contains('_selected')) {
                myProjectFunction.unSelectAllCheckbox();

                btnSelectAll.classList.remove('_selected');
                btnSelectAll.innerHTML = "Выбрать все"
            } else {
                myProjectFunction.selectAllCheckbox();

                btnSelectAll.classList.add('_selected');
                btnSelectAll.innerHTML = "Снять выбор"
            }
        });


        for (let i = 0; i < allCheckbox.length; i++) {
            allCheckbox[i].addEventListener('click', () => {
                if (allCheckbox[i].closest('.project-card_selected')) {
                    myProjectFunction.removeClassSelectedCard(allCheckbox[i])
                } else {
                    myProjectFunction.addClassSelectedCard(allCheckbox[i])
                }
            })
        }
    }
    myProjectWork()
}


function updateProjectsList()
{
    const $statusInput = $('[name=project-status]');
    const $spkInput = $('[name=project-spk]');
    const $dateInput = $('.datepicker__input');
    let data = new FormData;

    if ($statusInput.length) {
        data.append('status', $statusInput.val());
    }
    if ($spkInput.length) {
        data.append('spk', $spkInput.val());
    }
    if ($dateInput.length) {
        data.append('date', $dateInput.val());
    }

    let request = BX.ajax.runAction(getAction('filter_projects'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            $('.project-list-wrapper').html(successResponse.data.view);
            myProjectPage();
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
}

$(document).on('change', '.js-project-filter', function () {
    updateProjectsList();
})

$(document).on('change', '.js-project-search-select', function () {
    if ($(this).val()) {
        window.location.href = '/personal/projects/' + $(this).val() + '/';
    }
})

$(document).on('select2:select', '.js-work-func-code-search-select, .js-work-func-name-search-select', function () {
    if ($(this).val()) {
        let $select = $(this);
        let id = $(this).val();
        let $parent = $(this).parents('.input-wrap-work-functions');
        $.ajax({
            type: 'POST',
            url: '/ajax/work-function.php',
            data: {
                id: id,
            },
            dataType: 'json',
            success: function (data) {
                if (data.success === true) {
                    let newOption, $otherSelect;
                    if ($select.hasClass('js-work-func-name-search-select')) {
                        newOption = new Option(data.data.UF_CODE, data.data.ID, false, false);
                        $otherSelect = $parent.find('.js-work-func-code-search-select');
                    } else {
                        newOption = new Option(data.data.UF_NAME, data.data.ID, false, false);
                        $otherSelect = $parent.find('.js-work-func-name-search-select');
                    }
                    if (!$otherSelect.find("option[value='" + data.data.ID + "']").length) {
                        $otherSelect.append(newOption);
                    }
                    $otherSelect.val(data.data.ID).change();
                }
            }
        });
    }
})

$(document).on('click', '.download-projects', function () {
    const downloadProjectCheckboxSelector = '.projects-for-download';

    let projects = [];
    $(downloadProjectCheckboxSelector + ':checked').each(function () {
        projects.push($(this).val());
    })
    if (projects.length < 1) return false;
    let url = getUrl('project_pdf') + '?id=' + projects.toString();
    location.href = url;
})

$(document).on('click', '.js-create-group', function () {
    const downloadProjectCheckboxSelector = '.projects-for-download';

    let projects = [];
    $(downloadProjectCheckboxSelector + ':checked').each(function () {
        projects.push($(this).val());
    })
    if (projects.length < 2) {
        showMessagePopup({
            msg: 'Для создания группы необходимо выбрать минимум 2 проекта',
        });
        return false;
    }

    let data = new FormData;
    for (let i = 0; i < projects.length; i++) {
        data.append('projects[]', projects[i]);
    }

    let request = BX.ajax.runAction(getAction('create_project_group'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            let options = {msg: successResponse.data.message};
            if (successResponse.data.redirect) {
                options.redirect = successResponse.data.redirect;
            }
            showMessagePopup(options);
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message);
        }
    );

})

$(document).on('click', '.js-delete-from-group', function () {
    let id = $(this).data('id');
    let data = new FormData;
    data.append('id', id);

    let request = BX.ajax.runAction(getAction('delete_from_group'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            let options = {msg: successResponse.data.message};
            if (successResponse.data.redirect) {
                options.redirect = successResponse.data.redirect;
            }
            $('.delete-from-group-popup .mfp-close').click();
            showMessagePopup(options);
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message);
        }
    );
})

const workFunctionCodeSelectClass = '.js-work-func-code-search-select';
const workFunctionNameSelectClass = '.js-work-func-name-search-select';
const professionalStandardSelectClass = '.js-standards-search-select';

let select2InputText = '';

function initSearchSelect(selector, url) {
     window.selector = selector;
    $(document).find(selector).select2(Object.assign({
        minimumResultsForSearch: -1,
        language: 'ru',
        width: '100%',
    }, {
        ajax: {
            data: function (params) {
                select2InputText = params.term;
                let query = {
                    term: params.term,
                    type: 'public',
                    sessid: BX.message('bitrix_sessid')
                };
                if (window.selector === workFunctionCodeSelectClass || window.selector === workFunctionNameSelectClass) {
                    query.standardId = $(professionalStandardSelectClass).val();
                }
                return query;
            },
            url: url,
            type: 'POST',
            dataType: 'json',
            processResults: function (result) {
                return {
                    results: result.data
                };
            }
        },
    }))
}

function initMultipleSelect() {
    $('.js-multiple-select').select2(Object.assign({
        minimumResultsForSearch: -1,
        language: 'ru',
        width: '100%',
    }, {
        closeOnSelect: false,
        escapeMarkup: markup => {
            return `<span class="select2-results__value">${markup}</span>`;
        },
        templateSelection: data => {
            return `<span>${data.text}</span>`;
        },
    }));
}

$(() => {

    $('.js-select').select2({
        minimumResultsForSearch: -1,
        language: 'ru',
        width: '100%',
    });

    initMultipleSelect();

    $('.js-search-button').on('click', function () {
        /**
         * В select2InputText хранится текст запроса
         */
        if (select2InputText) {
            $.ajax({
                type: 'POST',
                url: '/ajax/projects.php',
                data: {
                    search: select2InputText,
                },
                success: function (data) {
                    $('.project-list-wrapper').html(data);
                }
            });
        }
    });

    initSearchSelect('.js-project-search-select', getUrl('project_search'));
    initSearchSelect(professionalStandardSelectClass, getUrl('standard_search'));
    initSearchSelect(workFunctionCodeSelectClass, getUrl('work_func_code_search'));
    initSearchSelect(workFunctionNameSelectClass, getUrl('work_func_name_search'));
});

$(document).on('change', professionalStandardSelectClass, function () {
    let data = new FormData();
    data.append('id', $(this).val());
    let request = BX.ajax.runAction(getAction('get_ps_requisites'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            const $requisitesInput = $('.ps-requisites');
            if ($requisitesInput.length) {
                $requisitesInput.val(successResponse.data);
                $('.input-wrap--ps-requisites').show();
                if (!$requisitesInput.parent('.group').hasClass('is-filled')) {
                    $requisitesInput.parent('.group').addClass('is-filled');
                }
            }
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );

})
$('.js-datepicker').datepicker({
    dateFormat: 'dd.mm.yy',
    onSelect: function() {
        $('.datepicker-block__input').change();
    }
});
$(() => {
    $('body').on('click', '.js-add-markup', function(e) {
        e.preventDefault();

        const $parentMarkup = $(this).closest('.js-parent-markup');

        addMarkup({
            to: $parentMarkup.find('.js-target-markup'),
            origin: $parentMarkup.find('.js-clone-markup').first(),
        });
    });

    $('body').on('click', '.js-delete-markup', function() {
        $(this).closest('.js-clone-markup').remove();
    });

    $('body').on('click', '.js-add-work-function', function() {
        addWorkFunctionsBlock();
    });

    // Удаление разметки
    $('body').on('click', '.js-remove-markup-btn', function() {
        removeMarkup($(this).closest('.js-remove-markup'));
    });

    // Добавление email'а получателей на странице create-mailing.html
    $('body').on('click', '.js-add-recipient-email', function() {
        const $this = $(this);

        addMarkup({
            to: $this.closest('.js-parent-markup').find('.js-target-markup').first(),
            markup: `<div class="row mb-20 recipients__field-wrap align-items-center js-remove-markup">
                <div class="col-10">
                    <div class="group">
                        <input name="email[]" class="input" type="text" required>
                        <span class="highlight"></span>
                        <label class="group__label">E-mail</label>
                    </div>
                </div>
                <div class="col-2">
                    <span class="delete-markup-btn js-remove-markup-btn"> 
                        <span class="delete-markup-btn__line-deg-45"></span>
                        <span class="delete-markup-btn__line-deg-45-revers"></span> 
                    </span>
                </div>
            </div>`
        });
    });

    // Добавление получателя на странице create-mailing.html
    $('body').on('click', '.js-add-recipient', function() {
        const $this = $(this);

        addMarkup({
            to: $this.closest('.js-parent-markup').find('.js-target-markup').first(),
            markup: `<div class="row mb-40 recipient-block js-remove-markup">
                <div class="container-fluid">
                    <div class="row mb-20 js-parent-markup">
                        <div class="col-8">
                            <div class="row mb-20">
                                <div class="col">
                                    <div class="group">
                                        <input name="organization" class="input" type="text" required>
                                        <span class="highlight"></span>
                                        <label class="group__label">Название организации</label>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="group">
                                        <input name="user_name" class="input" type="text" required>
                                        <span class="highlight"></span>
                                        <label class="group__label">Обращение в&nbsp;письме</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="js-target-markup">
                                <div class="row mb-20 recipients__field-wrap align-items-center">
                                    <div class="col">
                                        <div class="group">
                                            <input name="email[]" class="input" type="text" required>
                                            <span class="highlight"></span>
                                            <label class="group__label">E-mail</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col recipients__btn-wrap">
                                    <button type="button" class="btn btn_transparent-icon js-add-recipient-email">
                                        <svg class="i _default">
                                            <use xlink:href="#plus-rounded" />
                                        </svg>
                                        <span>Добавить email</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <button type="button" class="btn btn_transparent-icon js-remove-markup-btn">
                                <svg class="i _default btn__svg">
                                    <use xlink:href="#plus-rounded"></use>
                                </svg>
                                <span>Удалить получателя</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>`
        });

    });

    // Удаляем разметку
    function removeMarkup(el) {
        el.remove();
    }

    // Добавляем разметку
    function addMarkup(opts) {
        const { to, origin, markup, maxlimit } = opts;

        if (!origin && !markup) {
            throw new Error('Укажите ноду или разметку');
        }

        if (origin) {
            let originClone = origin.clone();

            /** временная история добавления кнопки удаления */
            // originClone.find('.fieldset').append(deleteMarkupButton(
            //     {
            //         classes: 'mt-19 ml-10'
            //     }
            // ));

            // originClone.find('.input-wrap_70').removeClass('input-wrap_70').addClass('input-wrap_60');

            // originClone.find('.group').append(deleteMarkupButton(
            //     {
            //         classes: 'mt-10 ml-15'
            //     }
            // ));
            /** конец временной истории добавления кнопки удаления */

            originClone.appendTo(to);

        } else {
            $(markup).appendTo(to);
        }
    }

    function addWorkFunctionsBlock() {
        let workFuncBlock = `
        <div class="input-wrap input-wrap_100 input-wrap-work-functions">
            <div class="fieldset">
                <div class="input-wrap input-wrap_30">
                    <select name="work_function[]" class="js-work-func-code-search-select js-edit-field" data-placeholder="Код трудовой функции" data-minimum-results-for-search="0" required>
                        <option></option>
                    </select>
                </div>
                <div class="input-wrap input-wrap_70">
                    <select name="work_function[]" class="js-work-func-name-search-select js-edit-field" data-placeholder="Наименование трудовой функции" data-minimum-results-for-search="0">
                        <option></option>
                    </select>
                </div>
            </div>
        </div>
        `;
        $('.work-functions-selects').append(workFuncBlock);
        initSearchSelect(workFunctionCodeSelectClass, getUrl('work_func_code_search'));
        initSearchSelect(workFunctionNameSelectClass, getUrl('work_func_name_search'));
    }

    function deleteMarkupButton(props = {}) {
        return `<div class="delete-markup-btn js-delete-markup ${[props.classes]}"> 
                    <div class="delete-markup-btn__line-deg-45"></div>
                    <div class="delete-markup-btn__line-deg-45-revers"></div> 
                </div>`;
    }

    function deleteMarkapButton2() {
        return `<div class="user-block-group__delete-btn ml-10 js-delete-markup"> 
                    <svg class="plus-svg plus-svg_rotate-45" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path class="plus-svg_red" d="M8.48566 4.24013H5.69714V1.4516C5.69714 1.06678 5.38551 0.754456 4.99999 0.754456C4.61447 0.754456 4.30284 1.06678 4.30284 1.4516V4.24013H1.51432C1.12879 4.24013 0.817169 4.55246 0.817169 4.93728C0.817169 5.3221 1.12879 5.63442 1.51432 5.63442H4.30284V8.42295C4.30284 8.80777 4.61447 9.1201 4.99999 9.1201C5.38551 9.1201 5.69714 8.80777 5.69714 8.42295V5.63442H8.48566C8.87119 5.63442 9.18281 5.3221 9.18281 4.93728C9.18281 4.55246 8.87119 4.24013 8.48566 4.24013Z" fill="white"/>
                    </svg>
                </div>`;
    }

    function createProjectPage() {

        function createProject() {
            let form = document.querySelector('.create-project-form')

            if (form === null) {
                return
            };

            let emptyBtn = form.querySelector('.js-add-empty-field')
            //let emptyField = form.querySelector('.empty-field')
            let docFields = form.querySelector('.create-project-form__add-doc')

            let deleteBtn = deleteMarkupButton({classes: 'mt-10 ml-10'});
            let cloneNode = `<div class="input-wrap input-wrap_100 js-clone-markup">
                                    <div class="group d-flex">
                                        <input class="input" name="document[]" type="text" required />
                                        <span class="highlight"></span>
                                        <label class="group__label">Документ</label>
                                                                            ${deleteBtn}
                                    </div>
                                </div>`;

            function insertAfter(elementInstertAfter, parentElement) {
                return parentElement.parentNode.insertBefore(elementInstertAfter, parentElement.nextSibling)
            };

            return {
                /* addDocFields() {
                    let clonedField = docFields.cloneNode(true)
                    insertAfter(clonedField, docFields);
                }, */

                addDocFields() {

                    docFields.insertAdjacentHTML('beforeend', cloneNode)
                },

                addEmptyField() {



/*                    const cloneEmptyNode =
                        $('.js-add-empty-field')
                        .closest('.create-project-form__fieldset')
                        .find('.js-clone-markup').first();


                    console.log(cloneEmptyNode);
                    console.log(cloneEmptyNode.length)
                    let emptyField = cloneEmptyNode.clone();
                    emptyField.find('.group').append(deleteMarkupButton({classes: 'm-8'}));
                    $('.empty-field').after(emptyField);*/


             /*       let deleteBtnNode = htmlToElements(deleteMarkupButton({classes: 'm-8'}))[0];
                    emptyField.children[0].appendChild(deleteBtnNode);
                    let clonedField = emptyField.cloneNode(true);
                    clonedField.getElementsByClassName('js-delete-markup')[0].remove();
                    let parentEmptyBtn = emptyBtn.closest('.input-wrap')
                    insertAfter(clonedField, parentEmptyBtn)*/

                }
            }
        }

        const myCreateProjectFunction = createProject();

        function createProjectPageWork() {
            const emptyBtnClass = '.js-add-empty-field';
            const addDocBtn = document.querySelector('.js-add-doc');
            const emptyBtn = document.querySelector(emptyBtnClass);

            $(emptyBtnClass).on('click', function () {
                const $parentMarkup = $(this).closest('.js-parent-markup');
                addMarkup({
                    to: $parentMarkup,
                    origin: $parentMarkup.find('.js-clone-markup').first(),
                });
            });

            if (addDocBtn) {
                addDocBtn.addEventListener('click', () => {
                    myCreateProjectFunction.addDocFields()
                    $('.js-datepicker').datepicker().data('datepicker');
                });
            }
        };

        createProjectPageWork()
    };

    createProjectPage();

})


$(document).on('click', 'form[name="create-project"] button', function () {
    $('button', $(this).parents('form')).removeAttr('clicked');
    $(this).attr('clicked', 'true');
})

$(document).on('submit', 'form[name=create-project]', function (event) {
    event.preventDefault();
    if (checkDevelopersCount() === false) {
        return false;
    }

    let $form = $(this);
    let data = new FormData($form[0]);
    let status = $('button[clicked=true]').data('status');
    data.append('status', status);

    let request = BX.ajax.runAction(getAction('create_project'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            showMessagePopup({
                msg: 'Проект создан',
            });
            $('.page-nav button').hide();
            $('.page-nav .btn_new_project').show();
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

function checkDevelopersCount() {
    const minDevelopersCount = 2;
    const developersAttentionClass = '.create-project-developer__attention';
    const validModificationClass = '_not-valid';

    let developersSelector = 'input[name="developers[]"]';
    let developersCount = $(developersSelector).length;

    let isValidDeveloperCount = (developersCount >= minDevelopersCount);

    updateDeveloperCountStatus(
        developersAttentionClass,
        validModificationClass,
        isValidDeveloperCount
    );

    return isValidDeveloperCount;
}


function updateDeveloperCountStatus(developersAttentionClass, modClass, status) {
    if(status === false) $(developersAttentionClass).addClass('_not-valid');
    else $(developersAttentionClass).removeClass('_not-valid');
}

$(document).on('change', professionalStandardSelectClass, function () {
    let standardInfoBlock = $('.profession-standard-info-block');
    if (standardInfoBlock.length) {
        standardInfoBlock.show();
    }
});

$(document).on('click', '.js-add-ps', function (event) {
    event.preventDefault();
    $(this).hide();
    $('.input-wrap--ps').hide();
    $('.input-wrap--ps-level').hide();
    $('.input-wrap--ps-requisites').hide();
    $('.input-wrap--add-ps').show();
    $('.js-select-ps').show();

    $('.profession-standard-info-block').show();
    $('.work-functions-wrapper').hide();

    $('input[name=new-ps]').attr('required', 'required');
    $('select[name="work_function[]"]').removeAttr('required');

    $('[name="work_function[]"]').val('').trigger('change');
    $('[name=professional-standard-additional]').val('');
    $('[name=professional-standard-requirements]').val('');

});
$(document).on('click', '.js-select-ps', function (event) {
    event.preventDefault();
    $(this).hide();
    $('.input-wrap--add-ps').hide();
    $('.input-wrap--ps').show();
    $('.input-wrap--ps-level').show();
    $('.input-wrap--ps-requisites').show();
    $('.js-add-ps').show();

    $('.profession-standard-info-block').hide();
    $('.work-functions-wrapper').show();

    $('select[name="work_function[]"]').attr('required', 'required');
    $('input[name=new-ps]').removeAttr('required');

    if ($('[name=standard-name]').val()) {
        $('.profession-standard-info-block').show();
    }
});

function Tabs() {
    let bindAll = function () {
        let menuElements = document.querySelectorAll('[data-tab]');
        for (let i = 0; i < menuElements.length; i++) {
            menuElements[i].addEventListener('click', change, false);
        }
    }

    let clear = function () {
        let menuElements = document.querySelectorAll('[data-tab]');
        for (let i = 0; i < menuElements.length; i++) {
            menuElements[i].classList.remove('active');
            let id = menuElements[i].getAttribute('data-tab');
            document.getElementById(id).classList.remove('active');
        }
    }

    let change = function (e) {
        clear();
        e.target.classList.add('active');
        let id = e.currentTarget.getAttribute('data-tab');
        document.getElementById(id).classList.add('active');
    }

    bindAll();
}
document.addEventListener("DOMContentLoaded", () => {
    let connectTabs = new Tabs();
})


document.addEventListener("DOMContentLoaded", () => {
    initChoiceDevelopers();
});

function initChoiceDevelopers() {
    if (document.querySelector('.choice-project-developers') === null) {
        return
    }

    $(document).on('change', '.js-choice-dev-checkbox', function () {
        checkContainsClass($(this)[0]);
    })
}

function checkContainsClass(checkbox) {
    if (checkbox.closest('.choice-project-developers-developer').classList.contains('_active')) {
        removeClassSelectedDeveloper(checkbox)
    } else {
        addClassSelectedDeveloper(checkbox)
    }
}

function addClassSelectedDeveloper(checkbox) {
    checkbox.closest('.choice-project-developers-developer').classList.add('_active')
}

function removeClassSelectedDeveloper(checkbox) {
    checkbox.closest('.choice-project-developers-developer').classList.remove('_active')
}

document.addEventListener("DOMContentLoaded", () => {
	let acc = document.querySelectorAll(".js-accordion");
	let i;

	for (i = 0; i < acc.length; i++) {
		acc[i].addEventListener("click", function () {
			this.classList.toggle("active");
			let panel = this.nextElementSibling;

			if (panel.style.display === "block") {
				panel.style.display = "none";
			} else {
				panel.style.display = "block";
			}
		});
	}

});
// TODO: всю эту шляпу надо как-то отрефакторить
$('body').on('change', '.js-loaddocs-input', function() {
    const $this = $(this);
    const $parent = $this.closest('.js-loaddocs');
    const $title = $parent.find('.js-loaddocs-title');
    const inputFile = $this.get(0);

    if (inputFile.files && inputFile.files.length) {
        $title.empty();

        [...inputFile.files].forEach((item) => {
            $title.append(`
                <div>
                    <span class="loaddocs__doc">
                        <svg class="i _contract loaddocs__icon">
                            <use xlink:href="#contract"></use>
                        </svg>
                        <span>${ item.name }</span>
                    </span>
                </div>
            `);
        });
    }
});

$('body').on('change', '.js-loadfile-input', function() {
    const $this = $(this);
    const $parent = $this.closest('.js-loadfile');
    const inputFile = $this.get(0);

    if (inputFile.files && inputFile.files.length) {
        $parent.find('.js-loadfile-title').html(`
            <span class="loadfile__doc">
                <svg class="i _contract loadfile__icon">
                    <use xlink:href="#contract"></use>
                </svg>
                <span>${ inputFile.files[0].name }</span>
            </span>
        `);
    }
});

$('body').on('change', '.js-loadbtn-input', function() {
    const $this = $(this);
    const $parent = $this.closest('.js-loadbtn');
    const inputFile = $this.get(0);
    const activeCls = 'is-active';

    if (inputFile.files && inputFile.files.length) {
        $parent.find('.js-loadbtn-title').html(`
            <span class="loadbtn__doc">
                <svg class="i _contract loadbtn__icon">
                    <use xlink:href="#contract"></use>
                </svg>
                <span>Документ ${ inputFile.files[0].name } загружен</span>
            </span>
        `).end()
        .find('.js-load-btn-item').removeClass(activeCls).end()
        .find('.js-load-btn-save').addClass(activeCls);
    }
});
$(() => {
    const $membersSlider = $('.js-members-slider');
    const $membersSliderInner = $('.js-members-slider-inner');
    
    initMembersSlider($membersSliderInner, $membersSlider);

    // $membersSliderInner.each(function() {
    //     const $this = $(this);
    //     const $membersSlider = $this.closest('.js-members-slider');

    //     if ($this.outerWidth() > $membersSlider.outerWidth()) {
    //         $this.not('.slick-initialized').slick({
    //             accessibility: false,
    //             variableWidth: true,
    //             appendArrows: $membersSlider,
    //             prevArrow: `<span class="slick-prev members-slider__arrow members-slider__arrow_prev">
    //                 <svg class="">
    //                     <use xlink:href="#members-prev-arrow"></use>
    //                 </svg>
    //             </span>`,
    //             nextArrow: `<span class="slick-next members-slider__arrow members-slider__arrow_next">
    //                 <svg class="">
    //                     <use xlink:href="#members-next-arrow"></use>
    //                 </svg>
    //             </span>`,
    //         });
    //     }
    // });

    // Пример добавления участника
    // addMember($membersSliderInner, $membersSlider, 'Александр Пирожков', 'https://via.placeholder.com/32');

    function addMember(sliderSel, sliderParentSel, name, avatar) {
        // Содержимое слайдера
        const slide = `<div class="members-slider__item">
            <div class="developer">
                <div class="developer__row">
                    <div class="developer__col">
                        <div class="developer__avatar-wrap">
                            <img src="${avatar}" alt="" class="developer__avatar">
                        </div>
                    </div>

                    <div class="developer__col">
                        <span class="developer__title text text_m">${name}</span>
                    </div>
                </div>
            </div>
        </div>`;

        // Если это слайдер, используем api слайдера, иначе вставляем разметку в элемент
        if (sliderIsInitialized(sliderSel)) {
            sliderSel.slick('slickAdd', slide);
        } else {
            sliderSel.append(slide);
        }

        initMembersSlider(sliderSel, sliderParentSel);
    }

    // Проверка на инит слайдера
    function sliderIsInitialized(sliderSel) {
        return sliderSel.hasClass('slick-initialized');
    }

    // Инициализация слайдера
    function initMembersSlider(sliderSel, sliderParentSel) {
        // Ничего не делаем при этом условии
        if (sliderSel.outerWidth() <= sliderParentSel.outerWidth() || sliderIsInitialized(sliderSel)) {
            return;
        }

        sliderSel.slick({
            accessibility: false,
            variableWidth: true,
            appendArrows: $membersSlider,
            prevArrow: `<span class="slick-prev members-slider__arrow members-slider__arrow_prev">
                <svg class="">
                    <use xlink:href="#members-prev-arrow"></use>
                </svg>
            </span>`,
            nextArrow: `<span class="slick-next members-slider__arrow members-slider__arrow_next">
                <svg class="">
                    <use xlink:href="#members-next-arrow"></use>
                </svg>
            </span>`,
        });
    }
});
document.addEventListener("DOMContentLoaded", () => {

    $('.js-tab-open-btn').on('click', function () {
        const tabTarget = $(this).data('tab-needle');
        const needleElement =  $("[data-tab-target='" + tabTarget +  "']");

        needleElement.css('display') == 'none'
        ?  needleElement.show(300)
            :  needleElement.hide(300);

        $(this).find('._arrow-tab').toggleClass('rotate-180');
    });

    const projectInner = document.querySelector('.project-inner');

    if (projectInner === null) {
        return;
    };

    function projectPage() {
        const targetToAddEmptyField = projectInner.querySelector('.target-to-add-empty-field');
        const targetToAddDoc = projectInner.querySelector('.target-to-add-project-doc');

        const innInner = projectInner.querySelectorAll('.inn-inner');


        const emptyField = `<div class="input-wrap input-wrap_100 empty-field hidden">
            <div class="group">
                <input name="additional_field" class="input js-edit-field" type="text" required />
                <span class="highlight"></span>
                <label class="group__label"></label>
            </div>
        </div>`;

        const emptyDoc = ` <div class="project-inner__wrapper">
            <div class="input-wrap input-wrap_100 js-accordion">
                <div class="group">
                    <input name="DOCUMENTS[]" class="input js-edit-field" type="text" required />
                    <span class="highlight"></span>
                    <label class="group__label">Документ</label>
                </div>
            </div>
        </div>
        `;

        return {
            addDocFields() {
                targetToAddDoc.insertAdjacentHTML('afterend', emptyDoc);
            },

            addEmptyField() {
                targetToAddEmptyField.insertAdjacentHTML('afterend', emptyField);
            },

            isEmptyBlockCommetns() {
                for (let i = 0; i < innInner.length; i++) {
                    if (!innInner[i].querySelector('.inn-all-comment')) {
                        innInner[i].classList.add('_no-comment');
                    }
                }
            }
        }
    };

    const myProjectFunction = projectPage();


    const btnAddEmptyField = projectInner.querySelector('.js-add-project-empty-field');
    const btnAddDocs = projectInner.querySelector('.js-add-project-doc');

    if (btnAddEmptyField) {
        btnAddEmptyField.addEventListener('click', () => {
            myProjectFunction.addEmptyField();
        });
    }

    if (btnAddDocs) {
        btnAddDocs.addEventListener('click', () => {
            myProjectFunction.addDocFields();
        });
    }

    /* Задать класс блоку без комментариев */
    myProjectFunction.isEmptyBlockCommetns();


    const editInputVals = [];

    $('.js-edit-field').on('focus', function () {
        const $this = $(this);

        // Если значение есть в объекте, то ничего не делаем
        if (editInputVals.includes((item) => item.id !== $this.data('id'))) {
            return;
        }

        editInputVals.push({
            id: $this.data('field-id'),
            val: $this.val(),
        });
    }).on('input', function () {
        const $this = $(this);
        const $parent = $this.closest('.group');
        const id = $this.data('field-id');
        const val = $this.val();

        const findInput = editInputVals.find((item) => item.id === id);

        // Если значение есть и изменилось
        if (findInput && $.trim(val) !== findInput.val) {
            $parent.addClass('is-changed');
        } else {
            $parent.removeClass('is-changed');
        }
    }).on('blur', function () {
        // const $this = $(this);
        // const $parent = $this.closest('.group');
        // const id = $this.data('id');
        // const val = $this.val();

        // const findInput = editInputVals.find((item) => item.id === id);

        // if (!$.trim(val)) {
        //     $this.closest('.group').removeClass('is-filled');
        // }
    });

    $(document).on('click', '.js-field-cancel',  function () {
        const $this = $(this);
        const $input = $this.closest('.group').find('.js-edit-field');
        const id = $input.data('field-id');
        const val = $input.val();

        $this.closest('.group').removeClass('is-changed');

        // $input.val();

        const findInput = editInputVals.find((item) => item.id === id);

        console.log(findInput);

        if (findInput) {
            $input.val(findInput.val);
        }

        $input.trigger('input');
        $input.trigger('change');

        // if (!$input.val()) {
        //     $input.closest('.group').removeClass('is-filled');
        // }
    });

    // $('.js-field-edit-icon').on('click', function(e) {
    //     const editInput = $(this).closest('.group').find('.js-edit-field');

    //     editInput.prop('readonly', false);
    //     editInput.focus();
    //     //Заблокируем дальнейшую отправку события в select
    //     return false;
    // });

    // $('.js-edit-field').focusout(function () {
    //     //Если readonly input был false, то его меняли
    //     //Отправляем данные
    //     if($(this).prop("readonly") == false) {
    //         //отправка данных
    //     }
    //     $(this).prop("readonly", true);
    // })
});

$(document).on('submit', 'form[name=change-status]', function (event) {
    event.preventDefault();

    let $selectedOption = $(this).find('select option:selected');
    if ($selectedOption.data('redirect')) {
        document.location.href = $selectedOption.data('redirect');
        return false;
    }
    if ($selectedOption.data('popup')) {
        let popupId = $selectedOption.data('popup');
        console.log(popupId);
        $.magnificPopup.open({
            items: {
                src: `#${popupId}`,
                type: 'inline',
            },
        });
        return false;
    }

    let data = new FormData($(this)[0]);
    let request = BX.ajax.runAction(getAction('project_status_change'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            showMessagePopup({
                msg: 'Статус обновлён',
                redirect: successResponse.data.redirect
            });
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(document).on('submit', 'form[name=add-project-comment]', function (event) {
    event.preventDefault();
    let data = $(this).serialize();
    $.ajax({
        type: 'POST',
        processData: false,
        url: getUrl('add_comment'),
        data: data,
        dataType: 'json',
        success: function (data) {
            if (data.success === true) {
                showMessagePopup({
                    msg: 'Комментарий добавлен',
                    redirect: document.location.href
                });
            } else {
                alert(data.message);
            }
        },
    });
})

$(document).on('change', '.project-inner--detail .js-edit-field', function () {
    let $input = $(this);
    let name = $(this).attr('name');
    let $inputs = $('.js-edit-field[name="' + name + '"]');

    let propertyCode = name;
    if ($input.data('property')) {
        propertyCode = $input.data('property');
    }

    let value;
    if ($inputs.length > 1) {
        value = [];
        $inputs.each(function () {
            value.push($(this).val());
        })
    } else {
        value = $input.val();
    }
    let url = getUrl('project_field_edit');
    if ($input.data('action')) {
        url = getUrl($input.data('action'));
    }
    let data = {
        id: $('input[name=project-id]').val(),
        value: value,
        propertyCode: propertyCode,
    };
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        dataType: 'json',
        success: function (data) {

        },
    });
});


$(document).on('click', 'form[name=spk-approval] button', function () {
    $('button', $(this).parents('form')).removeAttr('clicked');
    $(this).attr('clicked', 'true');
});

$(document).on('submit', 'form[name=spk-approval]', function (event) {
    event.preventDefault();
    let $form = $(this);
    let data = new FormData($form[0]);
    let changeStatus = $('button[clicked=true]').data('change-status');
    data.append('change-status', changeStatus);

    let request = BX.ajax.runAction(getAction('add_spk_result'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            let options = {msg: successResponse.data.message};
            if (successResponse.data.redirect) {
                options.redirect = successResponse.data.redirect;
            }
            showMessagePopup(options);
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(document).on('submit', 'form[name=return-to-nark]', function (event) {
    event.preventDefault();
    let $form = $(this);
    let data = new FormData($form[0]);

    let request = BX.ajax.runAction(getAction('return_project_to_nark'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            document.location.href = successResponse.data.redirect
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(document).on('click', '.js-remake-project', function (event) {
    event.preventDefault();
    let projectId = $(this).data('id');
    let data = new FormData();
    data.append('id', projectId);

    let request = BX.ajax.runAction(getAction('project_remake'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            showMessagePopup({
                msg: successResponse.data.message,
                redirect: successResponse.data.redirect
            });
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
})

$(document).on('click', '.add-comment-answer', function (event) {
    const commentWrapperClass = '.inn__wrapper-inn';
    const commentAnswerBlockClass = '.inn-all-comment';
    const addCommentAnswerBlockClass = '.comments-answer-wrapper';
    let $parent = $(this).parents(commentWrapperClass);
    $parent.find(addCommentAnswerBlockClass + ':hidden').show();
    $parent.find(commentAnswerBlockClass + ':hidden').show();
})

$(document).on('click', '.js-like-comment', function (event) {
    const likeCountClass = '.inn-indicator__count';

    let $likeBlock = $(this);
    let $likeCount = $(this).find(likeCountClass);
    let value = parseInt($likeCount.text());
    let data = {
        comment_id: $(this).data('comment-id'),
        value: $(this).data('value'),
    };

    $.ajax({
        type: 'POST',
        url: getUrl('like_comment'),
        data: data,
        dataType: 'json',
        success: function (data) {
            if(data.remove === true) {
                $likeBlock.removeClass('active');
                $likeCount.text(value - 1);
            } else {
                $likeBlock.addClass('active');
                $likeCount.text(value + 1);
                let $anotherLike = $likeBlock.siblings();
                if ($anotherLike.hasClass('active')) {
                    let $anotherLikeCount = $anotherLike.find(likeCountClass);
                    let anotherValue = parseInt($anotherLikeCount.text());
                    $anotherLikeCount.text(anotherValue - 1);
                    $anotherLike.removeClass('active');
                }
            }
        },
    });
});

$(document).on('change', '.js-status-change', function () {
    const hiddenDateClass = 'hidden-date';
    const $select = $(this);
    let $selectedOption = $select.find('option:selected');
    let $parentBlock = $select.parents('.status-change-block');
    if ($selectedOption.data('days')) {
        $parentBlock.addClass(hiddenDateClass);
    } else {
        $parentBlock.removeClass(hiddenDateClass);
    }
});

$(document).on('click', '.js-note-download', function (event) {
    event.preventDefault();

    const projectId = $(this).data('id');
    let data = new FormData;
    data.append('project-id', projectId);
    let request = BX.ajax.runAction(getAction('download_note'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            window.location.href = successResponse.data.filePath;
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(document).on('click', '.js-conclusion-download', function (event) {
    event.preventDefault();

    const projectId = $(this).data('id');
    let data = new FormData;
    data.append('project-id', projectId);
    let request = BX.ajax.runAction(getAction('download_conclusion'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            window.location.href = successResponse.data.filePath;
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(document).on('submit', 'form[name=add-projects-to-group]', function (event) {
    event.preventDefault();

    let data = new FormData($(this)[0]);
    let request = BX.ajax.runAction(getAction('add_projects_to_group'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            $('#create-group .mfp-close').click();
            showMessagePopup({
                msg: successResponse.data.message,
                redirect: successResponse.data.redirect
            });
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(document).on('submit', 'form[name=rename-group]', function (event) {
    event.preventDefault();

    let data = new FormData($(this)[0]);
    let request = BX.ajax.runAction(getAction('rename_group'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            window.location.href = successResponse.data.redirect;
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(document).on('submit', 'form[name="add-projects-to-group-search"]', function (event) {
    event.preventDefault();
    const $form = $(this);
    let data = new FormData($form[0]);
    let request = BX.ajax.runAction(getAction('project_group_search'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            let html = '';
            if (successResponse.data.length > 0) {
                successResponse.data.forEach(function (item) {
                    html += `<div class="choice-list__item">
                                <div class="developer">
                                    <label class="developer__inner js-developer-inner">
                                        <div class="developer__row">
                                            <div class="developer__col">
                                                <span class="text text_m">${item.text}</span>
                                            </div>
                                        </div>
    
                                        <span class="cont ml-auto">
                                            <input type="checkbox" class="checkbox js-choice-list-input" name="projects[]" value="${item.id}">
                                            <span class="checkmark"></span>
                                        </span>
                                    </label>
                                </div>
                            </div>`;
                    });
                $('#create-group .choice-list__inner').html(html);
            } else {
                $('#create-group .choice-list__inner').html('Ничего не найдено');
            }

        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(() => {
    const btnSelectProject = document.querySelectorAll('.js-tooltip');

    if (!btnSelectProject) {
        return;
    };

    [...btnSelectProject].forEach((item) => {
        const btnText = item.dataset.tooltip;

        tippy(item, {
            content: btnText,
            placement: 'bottom-start',
            interactive: true,
        });
    });
});

/**
 * @param {String} HTML representing any number of sibling elements
 * @return {NodeList}
 */
function htmlToElements(html) {
    const template = document.createElement('template');
    template.innerHTML = html;

    return template.content.childNodes;
}

$(document).on('submit', 'form[name="user-search"]', function (event) {
    event.preventDefault();
    const $form = $(this);
    const $parentBlock = $form.parents('.users-list-block');
    let data = new FormData($form[0]);
    let request = BX.ajax.runAction(getAction('users_search'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            let view = successResponse.data.view;
            let usersHtml = $(view).find('.choice-project-developers').html();
            $parentBlock.find('.choice-project-developers').html(usersHtml);
            Tabs();
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(document).on('submit', 'form[name="user-search-dialogue"]', function (event) {
    let data = new FormData($(this)[0]);
    let request = BX.ajax.runAction(getAction('users_search'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            let view = successResponse.data.view;
            let usersHtml = $(view).find('.choice-list__inner').html();
            $('.choice-list__inner').html(usersHtml);
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );

    /*event.preventDefault();
    let data = $(this).serialize();
    $.ajax({
        type: 'POST',
        processData: false,
        url: getUrl('users_search'),
        data: data,
        success: function (data) {
            let usersHtml = $(data).find('.choice-list__inner').html();
            $('.choice-list__inner').html(usersHtml);
        },
    });*/
});

$(document).on('click', '.user-active', function (event) {
    event.preventDefault();
    let $btn = $(this);
    let data = {
        id: $btn.data('user-id'),
    };
    $.ajax({
        type: 'POST',
        url: '/ajax/activate-user.php',
        data: data,
        dataType: 'json',
        success: function (data) {
            if (data.success === true) {
                if (data.active === 'N') {
                    $btn.removeClass('btn_attention').addClass('bg_green');
                    $btn.text('Восстановить пользователя');
                } else {
                    $btn.removeClass('bg_green').addClass('btn_attention');
                    $btn.text('Удалить пользователя');
                }
            }
        },
    });
})

$(document).on('submit', 'form[name=change-password]', function (event) {
    event.preventDefault();
    let data = $(this).serialize();
    $.ajax({
        type: 'POST',
        processData: false,
        url: getUrl('change_password_by_checkword'),
        data: data,
        dataType: 'json',
        success: function (data) {
            if (data.success === true) {
                $('button').attr('disabled', 'disabled');
                $('.error-message').html('');
                showMessagePopup({
                    msg: data.message,
                });
                window.location.href = data.redirect;
            } else {
                $('.error-message').html(data.message);
            }
        },
    });
})

$(document).on('submit', 'form[name=add-user]', function (event) {
    event.preventDefault();
    let data = $(this).serialize();
    $.ajax({
        type: 'POST',
        processData: false,
        url: '/ajax/register-user.php',
        data: data,
        dataType: 'json',
        success: function (data) {
            $('form[name=add-user] .response-text').html(data.message).show();
        },
    });
})
$(document).on('change', 'form[name=add-user] select[name=group]', function (event) {
    const spkSelectWrapperClass = '.spk-select-wrapper';
    let $spkSelectWrapper = $(spkSelectWrapperClass);
    let $spkSelect = $spkSelectWrapper.find('select');
    let groupIdSpk = $spkSelectWrapper.data('group-id-show');
    if (parseInt($(this).val()) === groupIdSpk) {
        $spkSelectWrapper.show();
        $spkSelect.prop('required', true);
        $spkSelect.addClass('js-multiple-select');
        initMultipleSelect();
    } else {
        $spkSelectWrapper.hide();
        $spkSelect.prop('required', false);
        $spkSelect.val('');
    }
})

$(function() {
    svg4everybody();
    initCookiePopup();

    $('.js-news-slider-inner').each(function() {
        const $this = $(this);

        $this.not('.slick-initialized').slick({
            appendArrows: $this.closest('.js-news-slider').find('.js-news-slider-nav'),
            slidesToShow: 3,
            prevArrow: `<button type="button" class="slick-prev news-slider__arrow news-slider__arrow_prev">
                <svg class="i news-slider__arrow-icon">
                    <use xlink:href="#arrow-left" />
                </svg>
            </button>`,
            nextArrow: `<button type="button" class="slick-next news-slider__arrow news-slider__arrow_next">
                <svg class="i news-slider__arrow-icon">
                    <use xlink:href="#arrow-right" />
                </svg>
            </button>`,
            responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                  }
                }
            ]
        });
    });

});

/**
 * Инициализация popup-ов
 */
function registerPopups() {
    const jsMagnificPopupPopupClass = '.js-magnific-popup';
    const defaultPopUpType = 'inline';

    /**
     * TODO: Сделать функцию для регистрации
     * по data аттрибуту
     */

    $(jsMagnificPopupPopupClass)
        .each(function (index) {
            //id - popup-a
            let popUpIdSrc =  $(this).data('popup-target');

            //Если id не начинается с `#` добавим его.
            popUpIdSrc = popUpIdSrc.startsWith('#') ? popUpIdSrc : '#' + popUpIdSrc;

            let popUpType = $(this).data('popup-type') ? $(this).data('popup-target') : defaultPopUpType;

            //Регистрируем
            $(this).magnificPopup({
                fixedContentPos: true,
                // fixedBgPos: true,
                overflowY: 'scroll',

                items: {
                    src: popUpIdSrc,
                    type: popUpType,
                    mainClass: 'mfp-with-zoom',
                }
            });
        }
    );


}


$(document).ready(function() {
    registerPopups();
});

$(document).on('click', '.close-mfp', function (event) {
    event.preventDefault();
    $('.mfp-close').click();
});

$(() => {
    $('body').on('click', '.js-add-comment', function() {
        $(this).replaceWith('<textarea name="UF_ANSWER_COMMENT" class="textarea" placeholder="Текст комментария"></textarea>');
    });
});

/**
 * Обработчик кнопки удаления разработчика
 */
$(document).on('click', '.js-delete-developer', function () {

    const developerFormId = '#add-developer-form';

    //Селектор разработчиков
    const developerSelector = 'input[name="developers[]"]';
    const userBlockGroupClass = '.user-block-group';


    let developerBlock = $(this).parents(userBlockGroupClass);
    let developerId = developerBlock.find(developerSelector).val();


    let developerSelectorById = '.choice-project-developers-developer[data-user-id='+developerId+']';

    $(developerFormId)
        .find(developerSelectorById)
        .removeClass('_active')
        .find('input[type=checkbox]')
        .prop('checked', false);

    $(this).parents(userBlockGroupClass).remove();
    if ($(developerSelector).length) {
        $(developerSelector).first().change();
    }

    checkDevelopersCount();
});


$( ".add-developer-form" ).submit(function( event ) {
    event.preventDefault();

    let $form = $(this);

    const choiceActiveDevelopersClass = '.choice-project-developers-developer._active';
    const developerNameClass = '.choice-project-developers-developer__name';
    const developerImgClass = '.choice-project-developers-developer__img';
    const checkedDevelopers = $form.find(choiceActiveDevelopersClass);
    const developerBlocksAddBtnClass = '.create-project-developer__btn';
    const developerBlocksBtnContainer = '.create-project-developer__nav';
    const selectedDevelopersInput = 'input[name="developers[]"]';
    const parentUsersBlockClass = $form.find('[name=parent]').val();
    const $parentUsersBlock = $(parentUsersBlockClass);



    let developerBlocksFragment = '';

    let selectedDevelopersIds = [];
    $(selectedDevelopersInput).each(function(){
        const developerId = parseInt($(this).val());
        selectedDevelopersIds.push(developerId);
    });

    checkedDevelopers.each(function(index){
        const developer = {};
        developer.name = $(this).find(developerNameClass).text()
        developer.img = $(this).find(developerImgClass).data('developer-img');
        developer.id = parseInt($(this).data('user-id'));

        //Добавим html фрагмент в общий
        if (selectedDevelopersIds.indexOf(developer.id) === -1) {
            developerBlocksFragment += createDeveloperBlock(developer);
        }

    });

    //Вставим созданый html фрагмент в контейнер
    $parentUsersBlock.find(developerBlocksBtnContainer).before(developerBlocksFragment);
    checkDevelopersCount();

    $(selectedDevelopersInput).first().change();
    $('.mfp-close').click();
});



/**
 *
 * @object developer
 * @returns {string}
 */
function createDeveloperBlock(developer) {
    return `
                 <div class="user-block-group">
                        <input name="developers[]" data-property="users" class="js-edit-field" type="hidden" value="${developer.id}">
                        <div class="user-block-group__inner">
                            <div class="user-block-group__img" style="background-image: url(${developer.img});"> </div>
                            <span class="user-block-group__name">${developer.name}</span>

                            <div class="user-block-group__delete-btn ml-10 js-delete-developer">
                                <svg class="plus-svg plus-svg_rotate-45" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path class="plus-svg_red" d="M8.48566 4.24013H5.69714V1.4516C5.69714 1.06678 5.38551 0.754456 4.99999 0.754456C4.61447 0.754456 4.30284 1.06678 4.30284 1.4516V4.24013H1.51432C1.12879 4.24013 0.817169 4.55246 0.817169 4.93728C0.817169 5.3221 1.12879 5.63442 1.51432 5.63442H4.30284V8.42295C4.30284 8.80777 4.61447 9.1201 4.99999 9.1201C5.38551 9.1201 5.69714 8.80777 5.69714 8.42295V5.63442H8.48566C8.87119 5.63442 9.18281 5.3221 9.18281 4.93728C9.18281 4.55246 8.87119 4.24013 8.48566 4.24013Z" fill="white"/>
                                </svg>
                            </div>

                        </div>
                    </div>
    `;
}

$('body').on('change', '.js-switch-checkbox', function () {
    const $this = $(this);
    const $parent = $this.closest('.js-switch');
    const $text = $parent.find('.js-switch-text');

    const textVal = $this.is(':checked') ? $text.data('switch-checked') : $text.data('switch-unchecked');

    $text.text(textVal);
});

const downloadBtnClass = '.download-doc-btn';
const uploadDocBlockClass = '.upload-doc';
const uploadDocInputClass = '.upload-expertise-doc';
const uploadDocSaveClass = '.js-load-btn-save';

$(document).on('submit', 'form[name="expertise-form"]', function (e) {
    e.preventDefault();

    const $form = $(this);
    let data = new FormData($form[0]);
    let request = BX.ajax.runAction(getAction('add_expertise'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            $(uploadDocBlockClass).show();
            $(downloadBtnClass).hide();
            window.location.href = successResponse.data.redirect;
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(document).on('change', uploadDocInputClass, function () {
    if ($(this).val()) {
        $(uploadDocSaveClass).show();
    }
});

$(document).on('click', '.js-repeat-expertise', function(e) {
    e.preventDefault();

    $('.js-loadfile-title').html('');
    $(uploadDocInputClass).val('');
    $(uploadDocSaveClass).removeClass('is-active');
    $('.js-load-btn-item').addClass('is-active');
    $(uploadDocBlockClass).hide();
    $(downloadBtnClass).show();
});

$(document).on('click', uploadDocSaveClass, function(e) {
    e.preventDefault();
    const data = new FormData();

    data.append('file', $(uploadDocInputClass)[0].files[0]);
    data.append('project-id', $('input[name=project-id]').val());

    let request = BX.ajax.runAction(getAction('add_expertise_file'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            showMessagePopup({
                msg: 'Экспертиза успешно сохранена',
                redirect: successResponse.data.redirect
            });
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});


$(document).on('change', '.js-avatar-change', function () {
    const file = $(this)[0].files[0];
    if (file.type.indexOf('image/') === -1) {
        alert('Неверный формат файла');
        return false;
    }

    let data = new FormData();
    data.append('file', file);

    let request = BX.ajax.runAction(getAction('change_avatar'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            window.location.reload();
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(document).on('submit', 'form[name=profile-edit]', function (e) {
    e.preventDefault();

    let data = new FormData($(this)[0]);
    let request = BX.ajax.runAction(getAction('edit_profile'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            showMessagePopup({
                msg: 'Данные успешно изменены',
            });
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(document).on('submit', 'form[name=change-profile-password]', function (e) {
    e.preventDefault();

    const data = $(this).serialize();
    const errorContainerClass = '.input-error-text';

    $(errorContainerClass).text('');

    $.ajax({
        type: 'POST',
        processData: false,
        url: getUrl('change_password'),
        data: data,
        dataType: 'json',
        success: function (data) {
            if (data.success === true) {
                $('.mfp-close').click();
                showMessagePopup({
                    msg: 'Данные успешно изменены',
                });
            } else {
                if (data.errorContainer && $(data.errorContainer).length) {
                    $(data.errorContainer).html(data.message);
                } else {
                    alert(data.message);
                }
            }
        },
    });
});

$(document).on('submit', 'form[name=create-mailing]', function (event) {
    event.preventDefault();

    let data = new FormData();
    data.append('project-id', $('[name=project-id]').val());
    data.append('time', $('[name=time]').val());
    data.append('text', $('[name=text]').val());
    data.append('title', $('[name=title]').val());
    data.append('type', $('[name=type]').val());

    let files, fileId;
    $('.js-loaddocs-mailing').each(function () {
        files = $(this).find('[type="file"]')[0].files;

        if (files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                data.append('files[]', files[i]);
            }
        } else {
            fileId = $(this).find('.file-id').val();
            if (fileId) {
                data.append('filesIds[]', fileId);
            }
        }
    });

    $('.recipient-block').each(function (i) {
        let $recipient = $(this);
        data.append(`recipients[${i}][organization]`, $recipient.find('[name=organization]').val());
        data.append(`recipients[${i}][user_name]`, $recipient.find('[name=user_name]').val());
        $recipient.find('[name="email[]"]').each(function (j) {
            let $email = $(this);
            data.append(`recipients[${i}][email][${j}]`, $email.val());
        });
    });

    let request = BX.ajax.runAction(getAction('create_mailing'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            showMessagePopup({
                msg: 'Рассылка отправлена',
                redirect: successResponse.data.redirect
            });
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(document).on('change', '.js-edit-mailing input, .js-edit-mailing textarea', function () {
    let $parent = $(this).parents('.js-edit-mailing');
    let $input = $(this);
    let data = new FormData();
    let inputType = $input.attr('type');
    switch(inputType) {
        case 'checkbox':
            data.append('value', $input.is(':checked'));
            break;
        case 'file':
            data.append('value', $input[0].files[0]);
            break;
        default:
            data.append('value', $input.val());
    }
    data.append('id', $parent.data('id'));
    data.append('property', $input.attr('NAME'));
    let request = BX.ajax.runAction(getAction('edit_mailing'), {
        data: data,
    });
    request.then(
        function(successResponse) {

        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(document).on('change', '.js-change-recipients', function () {
    let data = new FormData();
    data.append('group', $(this).val());
    data.append('project-id', $('input[name=project-id]').val());
    let request = BX.ajax.runAction(getAction('change_recipients'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            $('.mailing-group-doc').remove();
            let view = successResponse.data.view;
            let recipientsHtml = $(view).find('.recipients').html();
            $('.recipients').html(recipientsHtml);
            if (successResponse.data.new_files.length > 0) {
                successResponse.data.new_files.forEach(html => $('.loaddocs').last().after(html))
            }
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
});

$(document).on('click', '.js-generate-doc', function (event) {
    event.preventDefault();

    const projectId = $('input[name=project-id]').val();
    const templatePath = $(this).data('url');
    let data = new FormData;
    data.append('projectId', projectId);
    data.append('templatePath', templatePath);
    let request = BX.ajax.runAction(getAction('generate_from_template'), {
        data: data,
    });
    request.then(
        function(successResponse) {
            window.location.href = successResponse.data.filePath;
        },
        function (errorResponse) {
            alert(errorResponse.errors[0].message)
        }
    );
})

$(() => {
    const $scrollPane = $('.js-scroll-pane');

    $scrollPane.jScrollPane({
        autoReinitialise: true,
    })
    // .on('mousewheel', (e) => {
    //     e.preventDefault();
    // });
});
const detailDialogPageClass = '.dialogue-detail-page';
const sendMessageFormSelector = 'form[name="add-dialogue-message"]';
const messagesContainerClass = '.developers-list_dialogues';
const messagesTextareaSelector = '[name=message]';
const addUserSelector = 'form[name="add-dialogue-user"]';
const createDialogSelector = 'form[name="create-dialogue"]';
const unreadMessagesCountClass = '.unread-dialogue-messages';
const sendUserMessageBtnClass = '.js-send-message';

$(document).on('submit', createDialogSelector, function (event) {
    event.preventDefault();
    const data = $(this).serialize();
    $.ajax({
        type: 'POST',
        processData: false,
        url: getUrl('create_dialogue'),
        data: data,
        dataType: 'json',
        success: function (data) {
            if (data.success === true) {
                showMessagePopup({
                    msg: 'Диалог успешно создан',
                });
                window.location.href = data.redirect;
            } else {
                alert(data.message)
            }
        },
    });
});

$(document).on('submit', addUserSelector, function (event) {
    event.preventDefault();
    const data = $(this).serialize();
    $.ajax({
        type: 'POST',
        processData: false,
        url: getUrl('add_dialogue_user'),
        data: data,
        dataType: 'json',
        success: function (data) {
            if (data.success === true) {
                window.location.href = data.redirect;
            } else {
                alert(data.message)
            }
        },
    });
});

$(document).on('submit', sendMessageFormSelector, function (event) {
    event.preventDefault();
    const data = $(this).serialize();
    $.ajax({
        type: 'POST',
        processData: false,
        url: getUrl('add_dialogue_message'),
        data: data,
        dataType: 'json',
        success: function (data) {
            if (data.success === true) {
                updateDialogue('send');
            } else {
                alert(data.message)
            }
        },
    });
});


function updateDialogue(action) {
    $.ajax({
        url: window.location.href,
        success: function (data) {
            let messagesHtml = $(data).find(messagesContainerClass).html();
            let $messageContainer = $(messagesContainerClass);
            if (messagesHtml !== $messageContainer.html()) {
                $messageContainer.html(messagesHtml);
                scrollMessagesToBottom();
            }
            if (action === 'send') {
                $(messagesTextareaSelector).val('');
                scrollMessagesToBottom();
            }
        },
    });
}

function scrollMessagesToBottom()
{
    const $messageContainer = $(messagesContainerClass);
    let blockHeight = $messageContainer[0].scrollHeight;
    $messageContainer.scrollTop(blockHeight);
}

// Отправляем сообщение по нажатию Enter
$(document).on('keypress', messagesTextareaSelector, function (event) {
    if (event.which === 13 && event.shiftKey === false) {
        event.preventDefault();
        $(sendMessageFormSelector + ' button').click();
    }
});

$(document).on('click', sendUserMessageBtnClass, function (event) {
    event.preventDefault();

    let data = {
        'user': $(this).data('id'),
        'isPrivate': true
    };
    $.ajax({
        type: 'POST',
        url: getUrl('create_dialogue'),
        data: data,
        dataType: 'json',
        success: function (data) {
            if (data.success === true) {
                window.location.href = data.redirect;
            } else {
                alert(data.message)
            }
        }
    });
});

function updateLastVisitDate(setUnreadMessagesCount) {
    const dialogUserId = $(detailDialogPageClass).data('dialog-user-id');
    const data = {
        id: dialogUserId,
    };

    if (setUnreadMessagesCount === true) {
        data.returnUnreadMessagesCount = true;
    }

    $.ajax({
        type: 'POST',
        url: getUrl('update_dialogue_last_visit'),
        data: data,
        dataType: 'json',
        success: function (data) {
            if(setUnreadMessagesCount) {
                updateUnreadMessagesCount(data.unreadMessagesCount);
            }
        }
    });
}

function updateUnreadMessagesCount(count) {
    if ($(unreadMessagesCountClass).length) {
        $(unreadMessagesCountClass).text(count)
    }
}

document.addEventListener("DOMContentLoaded", () => {
    if ($(detailDialogPageClass).length) {
        scrollMessagesToBottom();
        updateLastVisitDate(true);
        setInterval(updateDialogue, 2000);
        $(document).on('mousemoveend', detailDialogPageClass, function () {
            updateLastVisitDate();
        })
    }
});

(function ($) {
    let timeout;
    $(document).on('mousemove', function (event) {
        if (timeout !== undefined) {
            window.clearTimeout(timeout);
        }
        timeout = window.setTimeout(function () {
            // trigger the new event on event.target, so that it can bubble appropriately
            $(event.target).trigger('mousemoveend');
        }, 100);
    });
}(jQuery));

$(document).on('click', '.js-clear-notifications', function (event) {
  event.preventDefault();
  let request = BX.ajax.runAction(getAction('clear_notifications'));
  request.then(
    function(successResponse) {
      document.location.reload();
    },
    function (errorResponse) {
      alert(errorResponse.errors[0].message)
    }
  );
});

$(document).on('submit', 'form[name="create-video-conference"]', function (event) {
  event.preventDefault();

  let data = new FormData($(this)[0]);
  let request = BX.ajax.runAction(getAction('create_conference_notifications'), {
    data: data,
  });
  request.then(
    function(successResponse) {
      $('.mfp-close').click();
      showMessagePopup({
        msg: 'Уведомления отправлены полльзователям',
      });
    },
    function (errorResponse) {
      alert(errorResponse.errors[0].message)
    }
  );
});

$(document).on('submit', 'form[name="notification-settings"]', function (event) {
  event.preventDefault();

  let data = new FormData($(this)[0]);
  let request = BX.ajax.runAction(getAction('change_notifications_settings'), {
    data: data,
  });
  request.then(
    function(successResponse) {
      $('.mfp-close').click();
      showMessagePopup({
        msg: 'Настройки сохранены',
      });
    },
    function (errorResponse) {
      alert(errorResponse.errors[0].message)
    }
  );
});

$(document).on('change', '#notification-settings .js-select-all', function () {
  let checkedValue = $(this).prop('checked');
  $(this).parents('form').find('input[type="checkbox"]:not(.js-select-all)').prop('checked', checkedValue).change();
});

function showMessagePopup(options) {
  const defaultOpts = {
    popupId: '#message-popup',
    popupMsgSel: '.js-ajax-msg',
    msg: 'Ваше сообщение успешно отправлено',
  };

  const opts = Object.assign({}, defaultOpts, options);

  $(opts.popupId).find(opts.popupMsgSel).empty().html(opts.msg);
  $.magnificPopup.open({
    items: {
      src: opts.popupId,
      type: 'inline',
    },
    callbacks: {
      close: function () {
        if (options && options.redirect) {
          document.location.href = options.redirect
        }
      }
    }
  });
}

$(document).on('submit', '.feedback-form', function (event) {
    event.preventDefault();
    let $form = $(this);
    let data = $form.serialize();
    let action = $form.attr('action');
    $.ajax({
        type: 'POST',
        processData: false,
        url: action,
        data: data,
        success: function (data) {
            showMessagePopup();
            $form.find('input[type="text"], textarea').val('');
        },
    });
});

function initCookiePopup() {
  const $popup = $('.js-cookie-popup');
  const delay = 3 * 1000;
  const cookieKey = 'acceptCookiePolicy';
  if(hasCookie() || !$popup.length) return


  setTimeout(() => {
      $popup.addClass('_active')
  }, delay);

  $popup.find('.js-accept-cookie').on('click', function() {
      addCookie()
      $popup.removeClass('_active');
  });

  function addCookie() {
      document.cookie = `${cookieKey}=true; path=/; expires=Fri, 25 Jun 2038 05:24:33 GMT`
  }

  function hasCookie() {
      const value = document.cookie.split('; ').find((i) => i.startsWith(cookieKey))
      return value === `${cookieKey}=true`
  }
}

